module.exports = __webpack_public_path__ + "img/huanbao2.749aee55.png";